import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * Automatically scrolls to top of page on route change
 * Also closes any open dropdowns/menus
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });

    // Close any open dropdowns by clicking outside
    // This will trigger blur events on any active elements
    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    });
    document.body.dispatchEvent(clickEvent);

    // Also blur any focused elements (like dropdowns)
    if (document.activeElement && document.activeElement !== document.body) {
      document.activeElement.blur();
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
